// Lib
import { FC } from "react";
import { useNavigate } from "react-router-dom";
// Types
import {
  ChargeFailureReasonLabel,
  ChargeStatusLabel,
  OrderResponseDto,
  OrderStatusLabel,
} from "types/orders";
// Theme
// Constants
import { ADMIN_ROUTES } from "consts";
// Helpers
import { convertToTitleCase } from "helpers/dataHelpers";
// Icons
import { PersonIcon, RightArrowIcon, LocationsIcon } from "icons";
// Components
import { Badge, ButtonLink, SummaryField } from "components";
// Styled
import { ContentBox, FlexContainer, SummaryItemsGrid } from "styled/Box";
import { Typography } from "styled/Typography";

interface SummaryProps {
  isLoading: boolean;
  data: OrderResponseDto;
}

export const Summary: FC<SummaryProps> = ({ isLoading, data }) => {
  const {
    sid,
    chargeStatus,
    orderStatus,
    chargeFailureReason,
    delivery,
    totalFmcCentsPrice,
    //TODO: remove comment after implementing locations
    // locationId,
    locationName,
  } = data || {};

  const navigate = useNavigate();

  const handleOpenCustomerProfile = () => {
    navigate(`${ADMIN_ROUTES.CUSTOMERS.path}/${data?.customerId}`);
  };

  //TODO: remove comment after implementing locations
  // const handleOpenLocation = () => {
  //   navigate(`${ADMIN_ROUTES.DELIVERY_AREAS.path}/${locationId}`);
  // };

  return (
    <ContentBox $column $gap={20}>
      <Typography.H2>Summary</Typography.H2>

      <SummaryItemsGrid>
        <SummaryField isLoading={isLoading} label="Order number" value={sid} />

        <SummaryField
          isLoading={isLoading}
          label="Customer"
          value={
            <FlexContainer $gap={4}>
              <PersonIcon />

              <FlexContainer $gap={8}>
                {/* //TODO: add customer name after BE changes */}
                <p>Customer</p>

                <ButtonLink
                  iconEnd
                  icon={<RightArrowIcon />}
                  title="See detail"
                  onClick={handleOpenCustomerProfile}
                />
              </FlexContainer>
            </FlexContainer>
          }
        />

        <SummaryField
          isLoading={isLoading}
          label="Order status"
          value={orderStatus && <Badge title={OrderStatusLabel[orderStatus]} />}
        />
        <SummaryField
          isLoading={isLoading}
          label="Charge status"
          value={
            chargeStatus && <Badge title={ChargeStatusLabel[chargeStatus]} />
          }
        />

        <SummaryField
          isLoading={isLoading}
          label="Delivery partner"
          value={
            delivery?.deliveryProvider &&
            convertToTitleCase(delivery.deliveryProvider)
          }
        />

        {chargeFailureReason && (
          <SummaryField
            isLoading={isLoading}
            label="Charge failure reason"
            value={
              <Badge title={ChargeFailureReasonLabel[chargeFailureReason]} />
            }
          />
        )}

        <SummaryField
          isLoading={isLoading}
          label="FM coins"
          value={totalFmcCentsPrice}
        />
        <SummaryField
          isLoading={isLoading}
          label="Location"
          value={
            <FlexContainer $gap={4}>
              <LocationsIcon />

              <FlexContainer $gap={8}>
                <p>{locationName}</p>

                {/* //TODO: remove comment after implementing locations */}
                {/* <ButtonLink
                  iconEnd
                  icon={<RightArrowIcon />}
                  title="See detail"
                  onClick={handleOpenLocation}
                /> */}
              </FlexContainer>
            </FlexContainer>
          }
        />
      </SummaryItemsGrid>
    </ContentBox>
  );
};
